import supabase from "./supabase.js";

/**
 * Searches for queer events using the ai-fetch-events edge function.
 *
 * @param {Object} params
 * @param {string} params.country - Country name (e.g., "Australia")
 * @param {string} [params.countryCode] - Country code (e.g., "AU")
 * @param {string} params.state - State or region name
 * @param {string} params.city - City name
 * @param {string} [params.prompt] - Custom search prompt
 * @returns {Promise<{events: Array, citations: Array, raw: string}>}
 */
export async function searchEventsWithAI({ country, countryCode, state, city, prompt }) {
    if (!country?.trim()) {
        throw new Error("Country is required");
    }

    if (!city?.trim()) {
        throw new Error("City is required");
    }

    const { data, error } = await supabase.functions.invoke('ai-fetch-events', {
        body: {
            country: country.trim(),
            countryCode: countryCode?.trim(),
            state: state?.trim(),
            city: city.trim(),
            prompt: prompt?.trim(),
        },
    });

    if (error) {
        console.error("[Edge Function Error]", error);
        throw new Error(
            error.message ||
            "Failed to fetch events from the edge function"
        );
    }

    if (data?.error) {
        console.error("[Edge Function Response Error]", data);
        throw new Error(
            data.error ||
            "Edge function returned an error"
        );
    }

    // Return the expected format: { events, citations, raw }
    return {
        events: data?.events || [],
        citations: data?.citations || [],
        raw: data?.raw || "",
    };
}
